import axios from 'axios';

const state = {
    data: [],
    select: [],
    orderables: [{
            title: 'Mensagem',
            name: 'message'
        },
        {
            title: 'Cadastrado em',
            name: 'created_at'
        }
    ],
    filterGroups: [{
        name: 'Message',
        filters: [{
                title: 'Mensagem',
                name: 'message',
                type: 'string'
            },
            {
                title: 'Cadastrado em',
                name: 'created_at',
                type: 'datetime'
            }
        ]
    }]
};

const mutations = {
    SET_MESSAGE: (state, payload) => {
        state.data = payload;
    },
    SET_MESSAGE_SELECT: (state, payload) => {
        state.select = payload;
    },
};

const actions = {
    setMessages: (context, payload) => {
        context.commit('SET_MESSAGE', payload);
    },
    setMessagesDeleted: (context, payload) => {
        context.commit('SET_MESSAGE_DELETED', payload);
    },
    storeMessage: (context, payload) => {
        return axios.post('/api/message/send', payload, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    },
    resendMessage: (context, payload) => {
        let promise = new Promise((resolve, reject) => {
            axios.post(`/api/message/${payload}/resend`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
        return promise;
    },

};
export default {
    state,
    mutations,
    actions
};